import { render } from "./Home.vue?vue&type=template&id=97b00676&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-97b00676"

export default script